import { render, staticRenderFns } from "./PhysicianImportView.vue?vue&type=template&id=2e4a49f0&"
import script from "./PhysicianImportView.vue?vue&type=script&lang=js&"
export * from "./PhysicianImportView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports